import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-up",
  "use": "icon-arrow-up-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" fill=\"currentColor\" aria-hidden=\"true\" class=\"\" id=\"icon-arrow-up\"><path d=\"M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol